import { Accordion } from "react-bootstrap";
import { useState, useEffect } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { BaseUrl } from "../../helper/BaseUrl";
import { toast } from "react-toastify";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import AdminHeader from "../../component/AdminHeader";

const addHomeWork = ApiEndpoints.weWork.create;
const getHomeWork = ApiEndpoints.weWork.list;
const deleteHomeWork = ApiEndpoints.weWork.delete;
const updateHomeWork = ApiEndpoints.weWork.update;

export default function WeWork() {
  const [weWorks, setWeWorks] = useState([]);
  const [previews, setPreviews] = useState({});

  const addwork = () => {
    setWeWorks([
      ...weWorks,
      {
        _id: null,
        icon: "",
        title: "",
        description: "",
      },
    ]);
  };

  const fetchData = async () => {
    try {
      const response = await ApiRequest("GET", getHomeWork,);
      const initialPreviews = response.how_we_works?.reduce((acc, work, index) => {
        acc[`work${index + 1}preview`] = `${BaseUrl}${work.icon}` || "";
        return acc;
      }, {});
      setWeWorks(response.how_we_works);
      setPreviews(initialPreviews);
    } catch (error) {
      console.error("Error fetching blog data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [])

  const handleChange = (id, field, value) => {
    setWeWorks((prevweWorks) =>
      prevweWorks?.map((work) =>
        work._id === id
          ? { ...work, [field]: value }
          : work
      )
    );
  };

  const handleImageChange = (id, field, e) => {
    const file = e.target.files[0];
    const workIndex = weWorks.findIndex((work) => work._id === id);
    const previewKey = `work${workIndex + 1}preview`;

    if (file) {
      // Update the preview state dynamically for icon 
      if (field === "icon") {
        setPreviews((prevPreviews) => ({
          ...prevPreviews,
          [previewKey]: URL.createObjectURL(file),
        }));
      }

      // Update the work's respective field
      setWeWorks((prevweWorks) =>
        prevweWorks?.map((work) =>
          work._id === id
            ? { ...work, [field]: file }
            : work
        )
      );
    } else {
      // Reset the preview state dynamically for icon
      if (field === "icon") {
        setPreviews((prevPreviews) => ({
          ...prevPreviews,
          [previewKey]: null,
        }));
      }

      // Reset the work's respective field
      setWeWorks((prevweWorks) =>
        prevweWorks?.map((work) =>
          work._id === id
            ? { ...work, [field]: null }
            : work
        )
      );
    }
  };


  const handleSubmit = async (id) => {
    const weWorkToSubmit = weWorks.find((work) => work._id === id);
    const isNew = weWorkToSubmit._id === null; // Check if it's a new work

    // Validation for null
    if (
      !weWorkToSubmit.icon || !weWorkToSubmit.description || !weWorkToSubmit.title
    ) {
      toast.error("All fields for work are required.");
      return;
    }

    const formData = new FormData();
    formData.append("title", weWorkToSubmit.title);
    formData.append("description", weWorkToSubmit.description);

    // Append bg image file
    if (weWorkToSubmit.icon instanceof File) {
      formData.append("icon", weWorkToSubmit.icon);
    }

    try {
      const apiEndpoint = isNew ? addHomeWork : updateHomeWork + weWorkToSubmit._id; // Define endpoints explicitly

      const response = await ApiRequest("POST", apiEndpoint, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success(response.message);
      fetchData();
    } catch (error) {
      console.error(isNew ? "Error adding work:" : "Error updating work:", error);
    }
  };

  const deletework = async (id) => {
    try {
      await ApiRequest("POST", `${deleteHomeWork}/${id}`);
      fetchData();
      toast.success("work deleted successfully.");
    } catch (error) {
      console.error("Error deleting work:", error);
    }
  };

  const pagename = {
    name: 'work Management',
    user: 'Admin',
    innerpage: 'work Management / weWorks'
  }
  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <div className="add-content-wrap">
          <div className="row">
            <div className="col-lg-12">
              <div className="home-slove-accord">
                <Accordion defaultActiveKey="0">
                  {weWorks?.map((work, index) => {
                    const previewKey = `work${index + 1}preview`;
                    return (
                      <Accordion.Item eventKey={index.toString()} key={work._id}>
                        <Accordion.Header>{`work ${index + 1}`}</Accordion.Header>
                        <Accordion.Body>
                          <form onSubmit={(e) => { e.preventDefault(); handleSubmit(work._id); }}>
                            <div className="row">

                              <div className="col-lg-7">
                                <div className="add-page-inputs work-description">
                                  <div className="label-wrap-add">
                                    <label>Descriptoin<small>*</small></label>
                                  </div>
                                  <DynamicCKEditor data={work.description} onChange={(event) => {
                                    const data = event.editor.getData();
                                    handleChange(work._id, "description", data);
                                  }} />
                                </div>
                              </div>

                              <div className="col-lg-5">
                                <div className="add-page-inputs">
                                  <div className="label-wrap-add">
                                    <label>Title<small>*</small></label>
                                  </div>
                                  <input type="text" className="form-control" placeholder="Enter Here" name="title" value={work.title} onChange={(e) => handleChange(work._id, "title", e.target.value)} />
                                </div>

                                <div className="add-page-inputs mt-4">
                                  <div className="label-wrap-add">
                                    <label>Icon: (150 × 150 px)<small>*</small></label>
                                  </div>
                                  <CustomImageUpload name="icon"
                                    onImageChange={(e) => handleImageChange(work._id, "icon", e)}
                                    imagePreview={previews[previewKey]}
                                    maxSize={200 * 1024} // 320KB
                                    acceptedFormats={[".webp", ".svg"]} />
                                </div>
                              </div>

                              <div className="col-lg-12">
                                <div className="btn-group-home-solve">
                                  <button type="submit" className="default-btn">save <span></span></button>
                                  <button onClick={() => deletework(work._id)} type="button" className="delete-solve"><img src="/assets/admin-delete.webp" alt="delete" className="img-responsive" /></button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </Accordion.Body>
                      </Accordion.Item>
                    )
                  })}
                  <div className="add-page-inputs">
                    <div className="addmore-images-client" onClick={addwork}>Add work +</div>
                  </div>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
